import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-no-data-found',
  templateUrl: './no-data-found.component.html',
  styleUrls: ['no-data-found.component.scss']
})
export class NoDataFoundComponent implements OnInit {

  @Input() warningMsg = 'No.data.found';

  constructor(private translate: TranslateService) { }

  ngOnInit() {}

}
